import { ServiceFieldOptionMessage } from "./ServiceFieldOptionMessage"

export class CreateServiceFieldMessage {
  name: string
  type: number
  serviceFieldOptions: ServiceFieldOptionMessage[]

  constructor(name: string, type: number, serviceFieldOptions: ServiceFieldOptionMessage[]) {
    this.name = name
    this.type = type
    this.serviceFieldOptions = serviceFieldOptions
  }
}